import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';
import { organisationNameSelector } from 'src/app/global/store/global.selectors';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {
    public organisationName$ = this.store.select(organisationNameSelector);

    constructor(private store: Store<State>) {}
}
